import React, { Component } from 'react';

import Text from '../shared/Text';
import { COMBAT_TIMEOUT } from '../../lib/constants';
import { isTimeout, getTimeoutTime } from '../../utils/combatUtils';
import { t } from '../../utils/appUtils';

import { CombatType } from '../../lib/types';

const LAST_TIMEOUT = 60;

type Props = {
  combat: CombatType;
  onFinished: () => void;
  hideTimer?: boolean;
};

export default class CombatTimeout extends Component<Props> {
  interval: any;

  componentDidMount() {
    this.interval = setInterval(() => {
      this.onCheckFinished();
      this.forceUpdate();
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  onCheckFinished() {
    const { combat, onFinished } = this.props;
    if (isTimeout(combat)) {
      onFinished();
      clearInterval(this.interval);
    }
  }

  render() {
    const { combat, hideTimer } = this.props;
    const timeout = COMBAT_TIMEOUT - getTimeoutTime(combat);
    if (hideTimer || timeout > LAST_TIMEOUT || timeout < 0) return null;
    return (
      <Text>
        {t('combat.timeout')}
        {': '}
        {timeout}
      </Text>
    );
  }
}
